import { render, staticRenderFns } from "./SettingsWrapper.vue?vue&type=template&id=5f9a135b"
import script from "./SettingsWrapper.vue?vue&type=script&lang=ts"
export * from "./SettingsWrapper.vue?vue&type=script&lang=ts"
import style0 from "./SettingsWrapper.vue?vue&type=style&index=0&id=5f9a135b&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports